import { TIME_FORMAT } from '../shared-constants/date'
import { weekday } from '../shared-constants/weekdays'
import { months } from '../shared-constants/monthNames'
import dayjs from 'dayjs';
dayjs().locale('fa')

export const getDateAndTime = (interedDate: any) => {
  if (!interedDate)
    return {
      date: '',
      time: '',
      year: '',
      monthName: '',
      dayOfWeek: '',
      dayOfMonth: '',
    }
  const newDate = new Date(interedDate)
  const date = interedDate
    ? new Intl.DateTimeFormat('fa-IR').format(newDate)
    : ''
  const time = interedDate
    ? dayjs(newDate).format(TIME_FORMAT)
    : ''

  const year = dayjs(interedDate).format('YYYY')
  const monthName = months[dayjs(interedDate).month()]
  const dayOfWeek = weekday[dayjs(interedDate).day()]
  const dayOfMonth = dayjs(interedDate).format('DD')

  const formatedDate = {
    date: date,
    time: time,
    year,
    monthName,
    dayOfWeek,
    dayOfMonth,
  }
  return formatedDate
}
